// @ts-nocheck
import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementFieldset'],
  (item, ctx) => {
    return {
      $el: 'fieldset',
      attrs: {
        class: 'formkit-section',
      },
      children: [
        {
          $el: 'legend',
          attrs: {
            class: 'formkit-section-title',
          },
          children: item.title,
        },
        ...ctx.buildChildren(item.element.items),
      ],
    }
  },
)
